<!--Marketing Slot Content-->
<div *ngFor ="let marketingSlotContent of marketingContents; let i = index">
<div id="{{ 'mmm-slotid-' + i }}">
  <pru-marketing-messages-slot-layout *ngIf="marketingSlotContent.showContent" [marketingSlotContent]="marketingSlotContent" 
      [marketingSlotTheme]="getBackgroundColorBasedOnTheme(marketingSlotContent.colorTheme)" [contentId]="contentId"
      [retirementLink]="retirementLink" >
  </pru-marketing-messages-slot-layout>
</div>
</div>










